import { t } from 'i18next';
import { FC } from 'react';
import useTacticCreate from './TacticForm.hook';
import { OneToOneDropMaterial } from './TacticsChannel/OneToOneDropMaterial';
import { OneToOneIVA } from './TacticsChannel/OneToOneIVA';
import { OneToOneKeyMessage } from './TacticsChannel/OneToOneKeyMessage';
import { Channel } from 'basics/enums/maya.enums';
import ActionButton from 'components/ActionButton';
import ContentCard from 'components/ContentCard';
import { formContainerActionsStyle } from 'components/FormContainer/FormContainer.style';
import { FormLayoutContainer } from 'components/FormLayout';
import { TacticFormPropsTypes } from 'components/TacticForm/TacticForm.types';
import { ApprovedEmail } from 'components/TacticForm/TacticsChannel/ApprovedEmail';
import { BroadcastEmail } from 'components/TacticForm/TacticsChannel/BroadcastEmail';
import { F2fEvent } from 'components/TacticForm/TacticsChannel/F2fEvent';
import { F2fMeeting } from 'components/TacticForm/TacticsChannel/F2fMeeting';
import { HybridEvent } from 'components/TacticForm/TacticsChannel/HybridEvent';
import { OneToOne } from 'components/TacticForm/TacticsChannel/OneToOne';
import { Telephone } from 'components/TacticForm/TacticsChannel/Telephone';
import { VirtualEvent } from 'components/TacticForm/TacticsChannel/VirtualEvent';
import { VirtualMeeting } from 'components/TacticForm/TacticsChannel/VirtualMeeting';
import { WebLogIn } from 'components/TacticForm/TacticsChannel/WebLogIn';
import { WebNoLogIn } from 'components/TacticForm/TacticsChannel/WebNoLogIn';
import TacticValidationDialog from 'components/TacticValidationDialog';
import Box from 'yoda-ui/components/Box';
import SelectYoda from 'yoda-ui/components/Form/SelectYoda';
import TextYoda from 'yoda-ui/components/Form/TextYoda';
import { YodaFormProvider } from 'yoda-ui/yodaForm';
import { YodaJustifyContent, YodaSpacing } from 'yoda-ui/yodaTheme';

const TacticForm: FC<TacticFormPropsTypes> = ({ isTemplate }) => {
  const {
    cancelButtonConfig,
    keyMessagesLoading,
    dropMaterialsLoading,
    allVeevaVaultDocumentsLoading,
    allVeevaVaultIVADocumentsLoading,
    providerFields,
    selectedChannel,
    submitButtonConfig,
    tacticFormConfig,
    requestAssetButtonConfig,
    tacticGroupLoading,
    showTacticGroup,
    openTacticValidationDialog,
    setOpenTacticValidationDialog,
    showLegacyOrderingFields,
  } = useTacticCreate(isTemplate);

  const FormDisplayByChannel = (channel: Channel) => {
    switch (channel) {
      case Channel.approvedEmail:
        return (
          < ApprovedEmail
            tacticFormConfig={ tacticFormConfig }
            tacticGroupLoading={ tacticGroupLoading }
            showTacticGroup={ showTacticGroup }
            approvedDocumentsLoading={ allVeevaVaultDocumentsLoading }
            showLegacyOrderingFields={ showLegacyOrderingFields }
          />
        );
      case Channel.broadcastEmail:
        return (
          < BroadcastEmail
            tacticFormConfig={ tacticFormConfig }
            tacticGroupLoading={ tacticGroupLoading }
            showTacticGroup={ showTacticGroup }
            showLegacyOrderingFields={ showLegacyOrderingFields }
          />
        );
      case Channel.f2fEvent:
        return (
          < F2fEvent
            tacticFormConfig={ tacticFormConfig }
            dropMaterialsLoading={ dropMaterialsLoading }
            IVADocumentsLoading={ allVeevaVaultIVADocumentsLoading }
            tacticGroupLoading={ tacticGroupLoading }
            showTacticGroup={ showTacticGroup }
            showLegacyOrderingFields={ showLegacyOrderingFields }
          />
        );
      case Channel.f2fMeeting:
        return (
          < F2fMeeting
            tacticFormConfig={ tacticFormConfig }
            keyMessagesLoading={ keyMessagesLoading }
            dropMaterialsLoading={ dropMaterialsLoading }
            tacticGroupLoading={ tacticGroupLoading }
            showTacticGroup={ showTacticGroup }
            IVADocumentsLoading={ allVeevaVaultIVADocumentsLoading }
            showLegacyOrderingFields={ showLegacyOrderingFields }
          />
        );
      case Channel.hybridEvent:
        return (
          < HybridEvent
            tacticFormConfig={ tacticFormConfig }
            dropMaterialsLoading={ dropMaterialsLoading }
            tacticGroupLoading={ tacticGroupLoading }
            showTacticGroup={ showTacticGroup }
            IVADocumentsLoading={ allVeevaVaultIVADocumentsLoading }
            showLegacyOrderingFields={ showLegacyOrderingFields }
          />
        );
      case Channel.oneToOne:
        return (
          < OneToOne
            tacticFormConfig={ tacticFormConfig }
            keyMessagesLoading={ keyMessagesLoading }
            dropMaterialsLoading={ dropMaterialsLoading }
            tacticGroupLoading={ tacticGroupLoading }
            showTacticGroup={ showTacticGroup }
            IVADocumentsLoading={ allVeevaVaultIVADocumentsLoading }
            showLegacyOrderingFields={ showLegacyOrderingFields }
          />
        );
      case Channel.oneToOneDropMaterial:
        return (
          < OneToOneDropMaterial
            tacticFormConfig={ tacticFormConfig }
            dropMaterialsLoading={ dropMaterialsLoading }
            tacticGroupLoading={ tacticGroupLoading }
            showTacticGroup={ showTacticGroup }
            showLegacyOrderingFields={ showLegacyOrderingFields }
          />
        );
      case Channel.oneToOneIVA:
        return (
          < OneToOneIVA
            tacticFormConfig={ tacticFormConfig }
            tacticGroupLoading={ tacticGroupLoading }
            showTacticGroup={ showTacticGroup }
            IVADocumentsLoading={ allVeevaVaultIVADocumentsLoading }
            showLegacyOrderingFields={ showLegacyOrderingFields }
          />
        );
      case Channel.oneToOneKeyMessage:
        return (
          < OneToOneKeyMessage
            tacticFormConfig={ tacticFormConfig }
            keyMessagesLoading={ keyMessagesLoading }
            dropMaterialsLoading={ dropMaterialsLoading }
            tacticGroupLoading={ tacticGroupLoading }
            showTacticGroup={ showTacticGroup }
            showLegacyOrderingFields={ showLegacyOrderingFields }
          />
        );
      case Channel.telephone:
        return (
          < Telephone tacticFormConfig={ tacticFormConfig }
            keyMessagesLoading={ keyMessagesLoading }
            tacticGroupLoading={ tacticGroupLoading }
            showTacticGroup={ showTacticGroup }
            showLegacyOrderingFields={ showLegacyOrderingFields }
          />
        );
      case Channel.virtualEvent:
        return (
          < VirtualEvent
            tacticFormConfig={ tacticFormConfig }
            tacticGroupLoading={ tacticGroupLoading }
            showTacticGroup={ showTacticGroup }
            IVADocumentsLoading={ allVeevaVaultIVADocumentsLoading }
            showLegacyOrderingFields={ showLegacyOrderingFields }
          />
        );
      case Channel.virtualMeeting:
        return (
          < VirtualMeeting
            tacticFormConfig={ tacticFormConfig }
            keyMessagesLoading={ keyMessagesLoading }
            tacticGroupLoading={ tacticGroupLoading }
            showTacticGroup={ showTacticGroup }
            IVADocumentsLoading={ allVeevaVaultIVADocumentsLoading }
            showLegacyOrderingFields={ showLegacyOrderingFields }
          />
        );
      case Channel.webLogIn:
        return (
          < WebLogIn
            tacticFormConfig={ tacticFormConfig }
            tacticGroupLoading={ tacticGroupLoading }
            showTacticGroup={ showTacticGroup }
            showLegacyOrderingFields={ showLegacyOrderingFields }
          />
        );
      case Channel.webNoLogIn:
        return (
          < WebNoLogIn
            tacticFormConfig={ tacticFormConfig }
            tacticGroupLoading={ tacticGroupLoading }
            showTacticGroup={ showTacticGroup }
            showLegacyOrderingFields={ showLegacyOrderingFields }
          />
        );
      default:
        return null;
    }
  };

  return (
    <YodaFormProvider { ...providerFields }>

      <ContentCard sx={ { margin: YodaSpacing.medium } }>
        <FormLayoutContainer justifyContent={ YodaJustifyContent.spaceBetween } >
          <FormLayoutContainer
            flexDirection="column"
            justifyContent={ YodaJustifyContent.spaceBetween }
          >

            <Box marginBottom={ YodaSpacing.large }>
              <SelectYoda { ...tacticFormConfig.channel } overflow={ 'auto' } maxHeight={ 500 }/>
            </Box>

            { FormDisplayByChannel(selectedChannel as Channel) }

            {
              isTemplate && selectedChannel && (
                <Box marginBottom={ YodaSpacing.large }>
                  <TextYoda { ...tacticFormConfig.comment } />
                </Box>
              )
            }

          </FormLayoutContainer>
        </FormLayoutContainer>
      </ContentCard>

      <Box sx={ formContainerActionsStyle } className='tacticFormButtonsWrapper'>
        { cancelButtonConfig ? <ActionButton { ...cancelButtonConfig } /> : <Box></Box> }
        { requestAssetButtonConfig && <ActionButton { ...requestAssetButtonConfig } /> }
        { submitButtonConfig && <ActionButton { ...submitButtonConfig } /> }
      </Box>

      <TacticValidationDialog
        title={ t('maya_tactic_form_validation_dialog_title') }
        open={ openTacticValidationDialog }
        setOpen={ setOpenTacticValidationDialog }
      >
      </TacticValidationDialog>
    </YodaFormProvider>
  );
};

export default TacticForm;

